import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import FilterText from "../FilterText";
import { IFilter } from "../../../../types/filter.type";
import FilterTimeFormTo from "../FilterTimeFormTo";

function FilterCRThuoc({ filter, setFilter, load }: IFilter) {
  const defaultFilter = {
    ten_thuoc: "",
    hoat_chat: "",
    hamluong: "",
    gdklh: "",
    duongdung: "",
    baoche: "",
    nhomthuoc: "",
    cssx: "",
    nuocsx: "",
    quycach: "",
    dvt: "",
    tbmt: "",
    cdt: "",
    soquyetdinh: "",
    slnhathau: "",
    diadiem: "",
    ngayquyetdinhFrom: null,
    ngayquyetdinhTo: null,
  };

  useEffect(() => {
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Stack sx={{ width: "100%" }} gap={2}>
      <FilterTimeFormTo
        label="Ngày quyết định"
        timeFrom={filter.ngayquyetdinhFrom}
        timeTo={filter.ngayquyetdinhTo}
        onChange={({timeFrom, timeTo}) => {
          setFilter({ ngayquyetdinhFrom: timeFrom, ngayquyetdinhTo: timeTo });
        }}
      />
      <FilterText
        direction="column"
        label="Tên thuốc"
        placeholder="Tìm theo tên thuốc"
        defaultValue={filter.ten_thuoc}
        onChange={(val) => setFilter({ ...filter, ten_thuoc: val })}
      />
      <FilterText
        direction="column"
        label="Hoạt chất"
        placeholder="Tìm theo tên hoạt chất"
        defaultValue={filter.hoat_chat}
        onChange={(val) => setFilter({ ...filter, hoat_chat: val })}
      />
      <FilterText
        direction="column"
        label="Hàm lượng"
        placeholder="Tìm theo tên hàm lượng"
        defaultValue={filter.hamluong}
        onChange={(val) => setFilter({ ...filter, hamluong: val })}
      />
      <FilterText
        direction="column"
        label="GĐKLH hoặc GPNK"
        placeholder="Tìm theo GĐKLH hoặc GPNK"
        defaultValue={filter.gdklh}
        onChange={(val) => setFilter({ ...filter, gdklh: val })}
      />
      <FilterText
        direction="column"
        label="Đường dùng"
        placeholder="Tìm theo đường dùng"
        defaultValue={filter.duongdung}
        onChange={(val) => setFilter({ ...filter, duongdung: val })}
      />
      <FilterText
        direction="column"
        label="Dạng bào chế"
        placeholder="Tìm theo dạng bào chế"
        defaultValue={filter.baoche}
        onChange={(val) => setFilter({ ...filter, baoche: val })}
      />
      <FilterText
        direction="column"
        label="Nhóm thuốc"
        placeholder="Tìm theo nhóm thuốc"
        defaultValue={filter.nhomthuoc}
        onChange={(val) => setFilter({ ...filter, nhomthuoc: val })}
      />
      <FilterText
        direction="column"
        label="Cơ sở sản xuất"
        placeholder="Tìm theo cơ sở sản xuất"
        defaultValue={filter.cssx}
        onChange={(val) => setFilter({ ...filter, cssx: val })}
      />
      <FilterText
        direction="column"
        label="Nước sản xuất"
        placeholder="Tìm theo nước sản xuất"
        defaultValue={filter.nuocsx}
        onChange={(val) => setFilter({ ...filter, nuocsx: val })}
      />
      <FilterText
        direction="column"
        label="Quy cách"
        placeholder="Tìm theo quy cách"
        defaultValue={filter.quycach}
        onChange={(val) => setFilter({ ...filter, quycach: val })}
      />
      <FilterText
        direction="column"
        label="Đơn vị tính"
        placeholder="Tìm theo đơn vị tính"
        defaultValue={filter.dvt}
        onChange={(val) => setFilter({ ...filter, dvt: val })}
      />
      <FilterText
        direction="column"
        label="Mã TBMT"
        placeholder="Tìm theo mã TBMT"
        defaultValue={filter.tbmt}
        onChange={(val) => setFilter({ ...filter, tbmt: val })}
      />
      <FilterText
        direction="column"
        label="Tên CĐT"
        placeholder="Tìm theo tên CĐT"
        defaultValue={filter.cdt}
        onChange={(val) => setFilter({ ...filter, cdt: val })}
      />
      <FilterText
        direction="column"
        label="Số quyết định"
        placeholder="Tìm theo số quyết định"
        defaultValue={filter.soquyetdinh}
        onChange={(val) => setFilter({ ...filter, soquyetdinh: val })}
      />
      <FilterText
        direction="column"
        label="Nhà thầu tham dự"
        placeholder="Tìm theo số nhà thầu tham dự"
        defaultValue={filter.slnhathau}
        onChange={(val) => setFilter({ ...filter, slnhathau: val })}
      />
      <FilterText
        direction="column"
        label="Địa điểm"
        placeholder="Tìm theo địa điểm"
        defaultValue={filter.diadiem}
        onChange={(val) => setFilter({ ...filter, diadiem: val })}
      />
    </Stack>
  );
}

export default FilterCRThuoc;
